import { green } from "@mui/material/colors";

export const panelsBackground = "#F7F8FA";
export const primary = "#3F51B5";
export const secondary = "#546179";
export const success = green[200];
